import { createAction, props } from '@ngrx/store';
import { StoreArgentina } from '@core/models'

export const STORE_ARGENTINA_FIND = createAction('[Store Argentina] Find', props<{ cuit: string }>());
export const STORE_ARGENTINA_FIND_SUCCESS = createAction('[Store Argentina] Find Success', props<{ storeArgentina: StoreArgentina }>());

export const STORE_ARGENTINA_FAILURE = createAction('[Store Argentina] Failure', props<{ error: string }>());
export const STORE_ARGENTINA_UPDATE_LOADING = createAction('[Store Argentina] Update Loading', props<{ loading: boolean }>());

